export const CLI_KIT_VERSION = '3.52.0'
